import { InertiaLink }     from "@inertiajs/inertia-react";
import React, { useState } from "react";
import { LabeledInput, LabeledSelect, ToggleSwitch }    from "@/Components/Form";
import { Inertia }         from "@inertiajs/inertia";
import { toast } from "react-toastify";
import { Formheader } from "@/Components/Formheader";

export default function TagForm({ tag, budget_tags }) {
  const [name, setName] = useState(tag?.name || '');
  const [changeToBudget, setChangeToBudget] = useState(false);
  const [isBudget, setIsBudget] = useState(tag?.budget || false);
  const [isDirty, setIsDirty] = useState(false);
  const [showBudgetModal, setShowBudgetModal] = useState(false);

  const updateValue = (e) => {
    setName(e.target.value);
    setIsDirty(true);
  }

  const updateBudgetCategories = () => {
    if (!changeToBudget) {
      const id = toast.error("Please select a new category", { autoClose: 5000 });
      return;
    }

    const id = toast.loading("Please wait...");
    const questionIds = tag.budgetQuestions.map((q) => q.id);
    Inertia.post(route('category.changebudget', {tag: changeToBudget, questionIds: questionIds}), {}, {
      onSuccess: (response) => {
        toast.update(id, { render: "The budget categories for the activities has been updated", type: toast.TYPE.SUCCESS, isLoading: false, autoClose: 5000 });
        setShowBudgetModal(false);
        // now save category
        handleUpdate(true);
      },
      onError: (error) => {
        console.log(error);
        toast.update(id, { render: "An error occurred while updating the category", type: toast.TYPE.ERROR, isLoading: false, autoClose: 5000 });
      }
    });
  }


  const handleUpdate = (skipPopup) => {
    if (!(skipPopup === true) && (tag?.budget && !isBudget && budget_tags.length > 1 && tag?.budgetQuestions.length > 0)) { // we need atleast 2 budget categories to be able to switch
        setShowBudgetModal(true);
        return;
    }

    const id = toast.loading("Please wait...");
    Inertia.put(`/categories/${tag.id}`, { name: name, budget: isBudget },
      {
        onSuccess: () => {
          toast.update(id, { render: "The category was successfully updated!", type: toast.TYPE.SUCCESS, isLoading: false, autoClose: 5000 });
          Inertia.visit('/categories');
        },
        onError: () => {
          toast.update(id, { render: "An error occurred while updating the category", type: toast.TYPE.ERROR, isLoading: false, autoClose: 5000 });
        }
      });
  }

  return (
    <>
      <div className="flex flex-row flex-wrap px-8 py-6 bg-gray-light">

        <div className="w-full">
          <Formheader>Category details</Formheader>
        </div>

        <div className="w-full mb-8">
          <LabeledInput placeholder="Enter a name" title="Heading" value={name} onChange={updateValue} disabled={tag?.is_global} />
        </div>

        <div className="flex items-start content-start w-full mb-8">
          <ToggleSwitch name="budget" type="checkbox" title="Is this category global?" checked={isBudget} disabled={tag?.is_global} onChange={(e) => { setIsBudget(!isBudget); setIsDirty(true); }} />
          <div className="ml-4">
              <span className="text-md">Show in your CO₂ budget</span>
              <p className="text-sm">By checking this box, the activities in which you use this category will be visualized in your CO₂ budget.</p>
          </div>
        </div>

        {tag?.questions?.length > 0 && (<>
          <p className="w-full mb-4 text-sm font-semibold text-typo-inactive uppercase">Connected activities</p>
          <div className="flex flex-wrap w-full gap-x-4 gap-y-1">
            {tag?.questions?.map((a, index) => {
              return (
              <InertiaLink
                href={`/library/activity/${a.id}/edit`}
                className="underline text-blue hover:no-underline"
                key={`activitylink_${a.id}-${index}`}
              >
                {a.title}
              </InertiaLink>
              )
            })}
          </div>
        </>)}
      </div>

      {tag?.is_global && <p className="mt-4 text-sm font-semibold text-typo-inactive uppercase">This tag is global and cannot be edited.</p>}
      {!tag?.is_global && (
        <div className="flex justify-end w-full gap-4 mt-4">
          <button className="btn" disabled={!isDirty} onClick={handleUpdate}>Save changes</button>
        </div>
      )}

      {showBudgetModal && (
        // Modal
        <div className="fixed inset-0 overflow-y-auto z-[1000]">
          <div className="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 transition-opacity" aria-hidden="true">
              <div className="absolute inset-0 bg-gray-500 opacity-75" onClick={() => setShowBudgetModal(false)}></div>
            </div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
            <div className="inline-block overflow-hidden text-left align-bottom transition-all transform bg-white shadow-xl sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
              <div className="p-4 bg-white sm:p-8 md:p-12">
                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:mt-0 sm:text-left">
                    <div className="inline-block px-3 py-1 leading-none text-white rounded-br-xl bg-apricot-dark">
                      <span className="text-md">
                        Something went wrong
                      </span>
                    </div>
                    <h3 className="mt-2 text-xl font-bold leading-6 text-gray-900">
                      This category is used in {tag?.budgetQuestions?.length} activities
                    </h3>
                    <div className="mt-2">
                      <p className="text-md">
                        Select another CO₂ budget category for the activities {tag?.budgetQuestions?.map((a, index) =>
                          <span key={`activity_${a.id}-${index}`} className="font-semibold">[{a.title}], </span>)}
                        to continue.
                      </p>
                      <div className="mt-4">
                        <LabeledSelect
                          icon="budget"
                          title="Choose a new category:"
                          options={budget_tags.filter((t) => t.id !== tag.id).map((t) => ({ value: t.id, label: t.name }))}
                          onChange={(e) => setChangeToBudget(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-row-reverse gap-4 mt-4 sm:mt-8 bg-gray-50">
                  <button type="button" className="btn" onClick={() => updateBudgetCategories()}>
                    Update activities
                  </button>
                  <button type="button" className="underline" onClick={() => setShowBudgetModal(false)}>
                    Never mind
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
